import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { nonInventoryListLayoutRoute } from '..';
import { nonInventoryInvoicesRouteSearchSchema } from './types';

export const nonInventoryInvoicesRoute = createRoute({
  getParentRoute: () => nonInventoryListLayoutRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./NonInventoryInvoicesView')),
  validateSearch: nonInventoryInvoicesRouteSearchSchema.parse,
});
